import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createFilterTemplateFailed, createFilterTemplateSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* createFilterTemplate(action) {
  try {
    const url = `${BACKEND_URL_V2}/filter-templates`;
    const response = yield makeRequest(url, action.payload, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createFilterTemplateSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createFilterTemplateFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(createFilterTemplateFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
